module.exports = __webpack_public_path__ + "img/01.9d17ce44.jpg";